import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import api from '../../services/api';
import { Truck, MapPin, CheckCircle, Clock } from 'lucide-react';
import toast from 'react-hot-toast';
import './Entregas.css';

const Entregas = () => {
  const [filtroStatus, setFiltroStatus] = useState('todos');
  const queryClient = useQueryClient();

  const { data: pedidos, refetch } = useQuery(
    ['pedidos-entregas', filtroStatus],
    async () => {
      const params = new URLSearchParams();
      if (filtroStatus !== 'todos') {
        params.append('status', filtroStatus);
      }
      const response = await api.get(`/api/pedidos?${params}`);
      return response.data.data.pedidos.filter(p => 
        p.tipoEntrega === 'delivery' && 
        ['Pronto', 'Saiu para entrega'].includes(p.status)
      );
    },
    {
      refetchInterval: 5000
    }
  );

  const updateStatusMutation = useMutation(
    ({ id, status }) => api.patch(`/api/pedidos/${id}/status`, { status }),
    {
      onSuccess: () => {
        toast.success('Status atualizado!');
        queryClient.invalidateQueries('pedidos-entregas');
      }
    }
  );

  return (
    <div className="entregas-page">
      <div className="page-header">
        <div>
          <h2><Truck size={28} /> Controle de Entregas</h2>
          <p>Gerencie as entregas em andamento</p>
        </div>
        <select
          value={filtroStatus}
          onChange={(e) => setFiltroStatus(e.target.value)}
          className="select-status"
        >
          <option value="todos">Todos</option>
          <option value="Pronto">Prontos</option>
          <option value="Saiu para entrega">Em Entrega</option>
        </select>
      </div>

      <div className="entregas-grid">
        {pedidos?.map(pedido => (
          <div key={pedido._id} className="entrega-card">
            <div className="entrega-header">
              <div>
                <h3>Pedido #{pedido.numero}</h3>
                <p className="cliente-nome">{pedido.cliente?.nome}</p>
              </div>
              <span className={`status-badge ${pedido.status === 'Saiu para entrega' ? 'em-entrega' : 'pronto'}`}>
                {pedido.status}
              </span>
            </div>

            <div className="endereco-entrega">
              <MapPin size={20} />
              <div>
                <p>{pedido.enderecoEntrega?.rua}, {pedido.enderecoEntrega?.numero}</p>
                <p>{pedido.enderecoEntrega?.bairro} - {pedido.enderecoEntrega?.cidade}</p>
                {pedido.enderecoEntrega?.referencia && (
                  <p className="referencia">Ref: {pedido.enderecoEntrega.referencia}</p>
                )}
              </div>
            </div>

            <div className="info-entrega">
              <div className="info-item">
                <span>Total</span>
                <strong>R$ {pedido.total?.toFixed(2)}</strong>
              </div>
              <div className="info-item">
                <span>Telefone</span>
                <strong>{pedido.cliente?.telefone}</strong>
              </div>
            </div>

            <div className="acoes-entrega">
              {pedido.status === 'Pronto' && (
                <button
                  className="btn btn-primary"
                  onClick={() => updateStatusMutation.mutate({ id: pedido._id, status: 'Saiu para entrega' })}
                >
                  <Truck size={20} />
                  Iniciar Entrega
                </button>
              )}
              {pedido.status === 'Saiu para entrega' && (
                <button
                  className="btn btn-success"
                  onClick={() => updateStatusMutation.mutate({ id: pedido._id, status: 'Entregue' })}
                >
                  <CheckCircle size={20} />
                  Marcar Entregue
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      {pedidos?.length === 0 && (
        <div className="empty-state">
          <Truck size={64} />
          <p>Nenhuma entrega no momento</p>
        </div>
      )}
    </div>
  );
};

export default Entregas;

